'use strict';

import angular from 'angular';

const postConfig = {
  headers: {
    'Content-Type': undefined
  },
  transformRequest: angular.identity
};

export default function f($http, $q, utils) {
  'ngInject';

  function uploadFile(path, file) {
    const formData = new FormData();
    formData.append('photo', file);

    return new $q((resolve, reject) => {
      const url = utils.getApiUrl(path);

      $http.post(url, formData, postConfig)
        .then(response => resolve(response.data))
        .catch(reject);
    });
  }

  return function uploadPhoto(url, files) {
    const promises = [];
    angular.forEach(files, file => promises.push(uploadFile(url, file)));

    return promises;
  };
}



// WEBPACK FOOTER //
// ./app/src/services/upload_photo.js